import Box from '@mui/material/Box'
import FormLabel from '@mui/material/FormLabel'
import { styled } from '@mui/system'
import type { Theme } from '@mui/system'

interface StyledProps {
  theme?: Theme
}

export const StyledFormLabel = styled(FormLabel)<StyledProps>(({ theme }) => ({
  mb: theme.spacing(5),
  fontWeight: '500',
  letterSpacing: '0.01em',
  whiteSpace: 'unset'
}))

export const StyledBox = styled(Box)<StyledProps>(({ theme }) => ({
  border: '1px solid lightgray',
  borderRadius: '50%',
  width: theme.spacing(5),
  height: theme.spacing(5)
}))
